import { cn } from '@forest/shared'
import { useStore } from '@nanostores/react'
import { $isCloseButtonVisible } from '~/store/close-button'

export function CloseButton(props: {
  className?: string
  onClick: () => void
}) {
  const isVisible = useStore($isCloseButtonVisible)
  if (!isVisible) return null
  return (
    <button
      className={cn(
        'grid size-9 place-items-center overflow-hidden animate-in slide-in-from-top',
        props.className,
      )}
      onClick={props.onClick}
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.28516 4.28516L12.8565 12.8565"
          stroke="white"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.28605 12.8565L12.8574 4.28516"
          stroke="white"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  )
}
